module.exports = __webpack_public_path__ + "static/media/team-3.d65ad72f.jpg";